import React ,{Component} from 'react'
import {withRouter,NavLink} from 'react-router-dom'
import {Container,Button} from 'reactstrap'
import './Signup.css';
import * as actionCreators from '../../Actions/Index';
import { connect } from "react-redux";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

class Card1 extends Component{
    constructor(props){
        super(props);
 
        this.state = {
            account: {},
            errors: {},
            errorMsg: "",
            name:"",
            username:"",
            userInfo:[],
            email:"",
            phoneNo: "",
        }
     }
     handleChange(field, e){         
        let account = this.state.account;
        account[field] = e.target.value;        
        this.setState({account});
    }
    handleValidation(){
        let account = this.state.account;
        let errors = {};
        let formIsValid = true;

        //Name
        if(!account["mail"]){
           formIsValid = false;
           errors["mail"] = "mail Cannot be empty";
        }
        if(account["mail"]){
            const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
           if (reg.test(account["mail"]) === true){
               this.state.email = account["mail"];
           }
           else{
            if(/^\d+$/.test(account["mail"])){
                this.state.phoneNo = account["mail"];
            }
            else{
                formIsValid = false;
                errors["inCorrect"] = "Email/PhoneNo is not valid";
            }
           }
        }
           if(!account["username"]){
           formIsValid = false;
           errors["username"] = "username Cannot be empty";
        }
        if(!account["password"]){
            formIsValid = false;
            errors["password"] = "password Cannot be empty";
         }
         if(!account["conpassword"]){
            formIsValid = false;
            errors["conpassword"] = "conpassword Cannot be empty";
         }
         if(account["conpassword"] != account["password"]){
            formIsValid = false;
            errors["notsame"] = "password doesnt match";
         }
       this.setState({errors: errors});
       return formIsValid;
    }

    contactSubmit(e){
        e.preventDefault();

        if(this.handleValidation()){
            this.state.errorMsg = "";
            var info = {};
                info["username"] = this.state.account["username"];
                info["password"] = this.state.account["password"];
                if(this.state.email != ""){
                    info["mail"] = this.state.email;
                }
                else{
                    info["phoneNo"] = this.state.phoneNo;
                }
            this.props.signup(info);
            this.setState({userInfo:this.props.userInfo});
           
          }
         else{
             if(this.state.errors["mail"]){
             this.state.errorMsg = "Email/PhoneNo cannot be empty!";
             }
             else if(this.state.errors["username"]){
                this.state.errorMsg = "UserName cannot be empty!";
                }
             else if(this.state.errors["password"]){
                    this.state.errorMsg = "Password cannot be empty!";
                    }
             else if(this.state.errors["conpassword"]){
                        this.state.errorMsg = "Confirm Password cannot be empty!";
                        }
             else if(this.state.errors["notsame"]){
                            this.state.errorMsg = "Password does not match!";
                            }
             else if(this.state.errors["inCorrect"]){
                              this.state.errorMsg = this.state.errors["inCorrect"];
                            }
            else{
                           this.state.errorMsg = "Something not right";
                            }
                 
        } 
    }
render(){return(
    <Container className="UPContainer">
    <div className="leftlogin">
             
    <div className="loginCard">

    <form name="contactform" className="contactform" onSubmit= {this.contactSubmit.bind(this)}>
          
    <div class="f0n8F FATdn " style={{marginTop: "5%"}}>
        <label for="f955a63d446b2c" class="_9nyy2">User Name</label>
        <input class="_2hvTZ pexuQ zyHYP" onChange={this.handleChange.bind(this, "username")} 
          name="username" type="text"/>
        </div>
        <div class="f0n8F FATdn " style={{marginTop: "5%"}}>
        <label for="f955a63d446b2c" class="_9nyy2">Phone number,or email</label>
        <input class="_2hvTZ pexuQ zyHYP"  onChange={this.handleChange.bind(this, "mail")} 
         name="mail" type="text"/>
        </div>
        <div class="f0n8F FATdn " style={{marginTop: "5%"}}>
        <label for="f955a63d446b2c" class="_9nyy2">Password</label>
        <input class="_2hvTZ pexuQ zyHYP" onChange={this.handleChange.bind(this, "password")} 
         name="password" type="password"/>
        </div>
    <div class="f0n8F FATdn " style={{marginTop: "5%"}}>
        <label for="f955a63d446b2c" class="_9nyy2">Confirm Password</label>
        <input class="_2hvTZ pexuQ zyHYP" onChange={this.handleChange.bind(this, "conpassword")} 
         name="conpassword" type="password"/>
        </div>
        <div className="errorMessage">
           <span>{this.state.errorMsg}</span>
           </div>
        <div className="loginButton hola">
           <Button type="submit" color="success">Sign Up</Button>
           </div>
           </form>
           
   </div>
   <div className="signupcard">
       <p className="signupp">Already have an account?<NavLink to="login"> Log In</NavLink></p>
   </div>
   </div>
</Container>
)}


}
const mapStateToProps = (state) => ({
    userExist:state.userExist,
    loginRequestStatus:state.loginRequestStatus,
    loginStatus:state.loginStatus,
    userInfo:state.userInfo
  })
  
  const mapDispatchToProps = dispatch => {
    return {
      signup: (account) => dispatch(actionCreators.signup(account))
    }
  }
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Card1));